import { createFileRoute } from '@tanstack/react-router';

import { AuthCallbackPage } from '@/features/auth/AuthCallbackPage';

/**
 * Magic-link landing route. Reads the `code` query parameter Supabase appends
 * to the redirect URL and exchanges it for a session; once the auth listener
 * fires, the page navigates on to `/plans`.
 */
export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackPage,
});
